// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getInActiveVouchersListApi } from "../../Service/Api/InActiveVouchersListApi"
import { getInActiveVouchersList,getErrors } from "../Reducer/InactiveVouchersListReducer"
 

 

// Watchers
function* inActivevouchersListSaga() {
	yield takeEvery("inactive_vouchers/getInActiveVouchers", getAllInActiveVouchers)
}

// Sagas
function* getAllInActiveVouchers(action) {
 
	try {
		const getInActiveVouchersData = yield call(getInActiveVouchersListApi, action.payload)
		// console.log(getCustomerVouchersApply.status);
		if (getInActiveVouchersData.request.status === 200) {
			yield put(getInActiveVouchersList(getInActiveVouchersData))
			// console.log(getCustomerVouchersApply.status);
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(inActivevouchersListSaga)])
}
